module.exports = "data:image/svg+xml;base64,77u/PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIwIDAgNDggNDgiIGZpbGw9InJnYmEoMjU1LCAyNTUsIDI1NSwgMSkiPgogICAgPHBhdGggZD0iTTQzLjk4IDE2YzAtMS40NC0uNzUtMi42OS0xLjg4LTMuNEwyNCAyIDUuOSAxMi42QzQuNzcgMTMuMzEgNCAxNC41NiA0IDE2djIwYzAgMi4yMSAxLjc5IDQgNCA0aDMyYzIuMjEgMCA0LTEuNzkgNC00bC0uMDItMjB6TTI0IDI2TDcuNDggMTUuNjcgMjQgNmwxNi41MiA5LjY3TDI0IDI2eiI+PC9wYXRoPgogICAgPHBhdGggZD0iTTAgMGg0OHY0OEgweiIgZmlsbD0ibm9uZSI+PC9wYXRoPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/icon/content-email.svg
// module id = 32
// module chunks = 0